<template>
    <b-card no-body>
        <div class="row p-2 align-items-end">
            <div class="col-md-3 mb-1">
                <label class="form-label">Başlangıç Tarihi</label>
                <input type="date" class="form-control" v-model="startDate" />
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Bitiş Tarihi</label>
                <input type="date" class="form-control" v-model="endDate" />
            </div>
            <div class="col-md-2 mb-1">
                <v-executer :loading="loading" :action="getData">Filtrele</v-executer>
            </div>
            <div class="col-md-4 mb-1 text-right">
                <p class="mb-0">Toplam tahsilat: <strong>{{ report.GrandTotal }}</strong> ({{ report.TotalTransactionCount }} işlem)</p>
            </div>
        </div>

        <table class="table">
            <thead>
                <tr>
                    <th class="text no-wrap">Plasiyer Kodu</th>
                    <th class="text no-wrap">İşlem Adedi</th>
                    <th class="text no-wrap">Toplam Tahsilat</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in report.Items" :key="index">
                    <td>{{ item.PlasiyerCode }}</td>
                    <td>{{ item.TransactionCount }}</td>
                    <td>{{ item.TotalAmount }}</td>
                </tr>
                <tr v-if="!loading && report.Items.length === 0">
                    <td colspan="3" class="text-center text-muted">Bu tarih aralığında tahsilat bulunamadı.</td>
                </tr>
            </tbody>
        </table>
    </b-card>
</template>
<script>
import { ReportApi } from '@/api/report'
import { BCard } from 'bootstrap-vue'

export default {
    components: {
        BCard
    },
    data() {
        return {
            loading: false,
            startDate: this.defaultStart(),
            endDate: this.today(),
            report: {
                Items: [],
                GrandTotal: "",
                TotalTransactionCount: 0
            }
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        today() {
            return new Date().toISOString().slice(0, 10)
        },
        defaultStart() {
            const d = new Date()
            d.setDate(d.getDate() - 30)
            return d.toISOString().slice(0, 10)
        },
        getData() {
            this.loading = true
            ReportApi.CollectionPerformanceReport({ StartDate: this.startDate, EndDate: this.endDate }).then(res => {
                this.loading = false
                this.report = res.data.Data
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
